import React, { useRef } from "react";
import { useEffect, useLayoutEffect, useState } from "react";
import useMobileBreakpoint from '@src/hooks/useMobileBreakpoint';
import Tile from '@project-stories/elements/Tile/Tile';
import Headings from '@project-stories/elements/Headings/Headings';
import { Paragraph } from '@arctheme-components/elements/Paragraph/Paragraph';
import helpers from 'frontend/js/helpers';

export default function FlexGrid({ settings, columns, headerText, subtext, tagline, columns_count: propColumnsCount, customId }) {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const section = settings.section;


  console.log(settings, 'flexgrid settings');

  // Responsive values from theme settings
  const columnsCount = isMobile ? section.columns_count_mobile : section.columns_count;
  const gapX = isMobile ? section.gap_mobile : section.gap;
  const gapY = isMobile ? section.gap_y_mobile : section.gap_y;
  const titleStyle = isMobile ? section.header_style_mobile : section.header_style;
  const taglineStyle = isMobile ? section.tagline_style_mobile : section.tagline_style;
  const contentStyle = isMobile ? section.subtext_style_mobile : section.subtext_style;


  // Group tiles by column
  const gridColumnTiles: any = [];
  columns.forEach((columnData) => {
    if (!gridColumnTiles[columnData.settings.column]) {
      gridColumnTiles[columnData.settings.column] = [];
    }
    gridColumnTiles[columnData.settings.column].push(columnData);
  });


  console.log(gridColumnTiles, 'gridColumnTiles');

  return (
    <div id={customId || undefined} className={`multicolumn-grid`}>
      {(tagline || headerText || subtext) && (
        <div
          className={`multicolumn-content-top w-full
          justify-${section.content_alignment_mobile}
          lg:justify-${section.content_alignment_desktop}
          text-${section.content_alignment_mobile}
          lg:text-${section.content_alignment_desktop}
          mb-[${section.header_margin_bottom_mobile}px]
          lg:mb-[${section.header_margin_bottom_desktop}px]
        `}
        >
          {tagline && (
            <Paragraph
              text={tagline}
              type={taglineStyle}
            />
          )}
          {headerText && (
            <Headings
              text={helpers.renderAccentText(headerText, section.accent_title_parts, section.accent_color)}
              type='h2'
              classes={titleStyle}
            />
          )}
          {subtext && (
            <Paragraph
              text={subtext}
              type={contentStyle}
            />
          )}
        </div>
      )}
      <div
        className={`grid ${gridColumnTiles.length > 1 ? `grid-cols-${columnsCount}` : ''}  w-full lg:h-auto ${settings.direction} justify-${section.content_alignment_mobile} lg:justify-${section.content_alignment_desktop}`}
      >
        {gridColumnTiles.map((groupedTiles, groupIndex) => {
          return (
            <div key={groupIndex} className={`flex flex-col`}>
              {groupedTiles.map((column, index) => {
                let columnWidth = isMobile ? column.settings.width_mobile : column.settings.width;
                const defaultFlexBasis = `${100 / columnsCount}%`;
                
                let flexBasis = columnWidth > 0
                  ? `calc(${columnWidth}% - ${gapX}px)`
                  : `calc(${defaultFlexBasis} - ${gapX}px)`;

                if (column.settings.main_aspect_ratio) {
                  columnWidth = isMobile
                    ? column.settings.mobile_block_height
                    : column.settings.block_height;

                  flexBasis = columnWidth > 0
                    ? `calc(${columnWidth}px - ${gapX}px)`
                    : `calc(${defaultFlexBasis} - ${gapX}px)`;
                }

                const columnHeight = isMobile ? column.settings.mobile_block_height : column.settings.block_height;
                const heightStyle = columnHeight > 0 ? `${columnHeight}px` : "auto";

                return (
                  <div
                    key={column.key || index}
                    style={{
                      flexBasis,
                      height: column.settings.layout === "default" ? heightStyle : undefined,
                      marginLeft: !settings.section.use_carousel && index % columnsCount !== 0 && !column.settings.main_aspect_ratio
                        ? `${gapX / 2}px`
                        : `${gapX / 2}px`,
                      marginRight: !settings.section.use_carousel && (index + 1) % columnsCount !== 0 && !column.settings.main_aspect_ratio
                        ? `${gapX / 2}px`
                        : `${gapX / 2}px`,
                      marginTop: `${gapY / 2}px`,
                      marginBottom: `${gapY / 2}px`,
                      ...(settings.section.use_carousel && {
                        marginLeft: `${gapX / 2}px`,
                        marginRight: `${gapX / 2}px`,
                      }),
                    }}
                    className="box-border  rounded-[${column.settings.border_radius_mobile}px] lg:rounded-[${column.settings.border_radius}px]"
                  >
                    <Tile
                      data={column}
                      layout={column.settings.layout}
                      height={heightStyle}
                      settings={settings}
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}